import { Component } from 'react';
import { Field } from 'redux-form';

import { GroupControl } from '../../../GroupField';
import YearControl from '../Control';

export default class YearGroupField extends Component {
  render() {
    return (
      <Field
        {...this.props}
        component={GroupControl}
        FormControl={YearControl}
      />
    );
  }
}
